import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menu\">\n<g clip-path=\"url(#menu_clip0_0_1)\">\n<path d=\"M475 73H25V105.143H475V73Z\" fill=\"#01203F\" />\n<path d=\"M475 233.714H25V265.857H475V233.714Z\" fill=\"#01203F\" />\n<path d=\"M378.571 394.429H25V426.572H378.571V394.429Z\" fill=\"#01203F\" />\n</g>\n<defs>\n<clipPath id=\"menu_clip0_0_1\">\n<rect width=\"450\" height=\"353.571\" fill=\"white\" transform=\"translate(25 73)\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol